import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
} from '@angular/core';

@Component({
	selector: 'app-radio-button',
	templateUrl: './radio-button.component.html',
	styleUrls: ['./radio-button.component.scss'],
})
export class RadioComponent implements OnInit {
	@Input() radioValue: { value: any; label: string }[];
	@Input() label: string;
	@Input() isRadioGroup: boolean;
	@Input() display: string = 'flex';
	@Input() selectedValue: string = '';
	@Output() onChangeEvent = new EventEmitter<string>();

	constructor() {
	}

	ngOnInit(): void {
	}

	onChange(value: string): void {
		this.onChangeEvent.emit(value);
	}
}
